import React, { useEffect, useState } from "react";
import { useProducts } from "../../../Api/newSockets.api";
import marketplace_tab_data from "../../../assets/mockedData/marketplace_tab_data";
import MarketplaceCard from "../../../components/Cards/MarketplaceCard";
import Header from "../../../components/Header/Header";
import Tabs from "../../../components/Tabs/Tabs";
import { savePathToLocalStorage } from "../../../utils/helpers";

const Devices = () => {
  savePathToLocalStorage();
  const {
    products,
    getProducts,
    connected,
  } = useProducts();
  const marketplace_tabs = marketplace_tab_data;
  const [inputValue, setInputValue] = useState("");

  useEffect(() => {
    if (!connected) return;
    getProducts().then((data: any) => console.log(data)).catch(() => {});
  }, [connected]);

  const filterProducts = () => {

  };

  console.log("Products", products);

  return (
    <div className="marketplace-container">
      <div className="marketplace-header-content">
        <Header
          title="Marketplace"
          // Implement searchFunction
          searchFunction={filterProducts}
        />
      </div>
      <div className="main-content-flex">
        <Tabs data={marketplace_tabs} />
        <div className="marketplace-body-content">
          <div className="marketplace-title-container">
            <div
              className="marketplace-libraries"
            >
              {products?.map((data) => (
                <MarketplaceCard
                  title={data.name}
                  description={data.description}
                  author={data.creator}
                  image={data.thumbnailUrl}
                  imported={data.imported}
                  mId={data.id}
                  price={data.price}
                  requestQuote = {true}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Devices;